// Network gate for non-essential beacons (views, traces, media reports, watch metrics) while a clip is still filling
// its buffer. The playing video always gets the link first: beacons run once the player has ≥ QUIET_AHEAD_SEC
// buffered ahead (or the clip is fully buffered / no clip is active), otherwise they wait — at most MAX_WAIT_MS — and
// always flush at once on pagehide so nothing is lost.
const QUIET_AHEAD_SEC = 4;
const MAX_WAIT_MS = 8000;
let video = { active: false, ahead: 0, full: false, at: 0 };
const queue = [];
let timer = null;

export const isNetQuiet = () => !video.active || video.full || video.ahead >= QUIET_AHEAD_SEC || Date.now() - video.at > 3000;

export function reportVideoBuffer({ active, aheadSec, fullyBuffered }) {
    video = { active: !!active, ahead: aheadSec || 0, full: !!fullyBuffered, at: Date.now() };
    if (queue.length && isNetQuiet()) flush();
}

function flush() {
    clearTimeout(timer); timer = null;
    while (queue.length) { const fn = queue.shift(); try { fn(); } catch { /* never block */ } }
}

export function whenQuiet(fn) {
    if (isNetQuiet()) { try { fn(); } catch { /* noop */ } return; }
    queue.push(fn);
    if (!timer) timer = setTimeout(flush, MAX_WAIT_MS);
}

if (typeof window !== "undefined") {
    window.addEventListener("pagehide", flush);
    document.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") flush(); });
}
